export default {
  startIcon: {
    marginRight: 10,
  },
};
